<template>
  <filtertron-tray-section
    v-if="field.type === 'file'"
    id="field-configurator-file-types"
    :title="lang.get('fields.form.file_types.text')"
    :initially-collapsed="true"
  >
    <div class="fields island">
      <div
        v-for="(group, groupName) in fileTypes"
        :key="groupName"
        class="island"
      >
        <b>{{ lang.get('files.types.' + groupName) }}</b>
        <checkbox-group
          :group-name="groupName"
          :group="group"
          :selected="field.fileTypes.filter(t => group.includes(t))"
          :select-all-label="lang.get('miscellaneous.select_all')"
          @selected="onSelected"
        />
      </div>
    </div>
  </filtertron-tray-section>
</template>

<script>
import { mapState } from 'vuex';
import CheckboxGroup from '@/lib/components/Shared/CheckboxGroup';
import FiltertronTraySection from '@/lib/components/Filtertron/FiltertronTraySection';
import handleInputMixin from '../handle-input-mixin.js';

export default {
  inject: ['lang'],
  components: {
    CheckboxGroup,
    FiltertronTraySection
  },
  mixins: [handleInputMixin],
  props: {
    field: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('entryForm', ['fileTypes'])
  },
  methods: {
    onSelected(checked, unchecked) {
      let fileTypes = [...this.field.fileTypes];

      checked.forEach(type => {
        if (!fileTypes.includes(type)) {
          fileTypes.push(type);
        }
      });

      fileTypes = fileTypes.filter(type => !unchecked.includes(type));

      this.$emit('input', { fileTypes });
    }
  }
};
</script>
